import { createAsyncThunk } from '@reduxjs/toolkit'
import Machine from './machine-model'
import { delete_machine, load_machines, store_machine } from './machine-service'

export const LoadMachinesAsync = createAsyncThunk<any, any>(
  'composer/load/machine',
  async (params: { uid: string }) => {
    return await load_machines(params)
  },
)

export const CreateMachineAsync = createAsyncThunk<any, any>(
  'composer/create/machine',
  async (params: Machine) => {
    return await store_machine(params)
  },
)

export const DeleteMachineAsync = createAsyncThunk<any, any>(
  'composer/delete/machine',
  async (params) => {
    return await delete_machine(params)
  },
)
